export default {
  guest: {
    earn_pts: 'Zdobądź {{points}} pkt za to zamówienie',
    tagline: 'Zbieraj nagrody. Każde zamówienie, za każdym razem.',
    pick_reward: 'Wybierz co chcesz, gdy zbierzesz punkty',
    free_at: 'gratis przy {{points}} pkt',
    save_at: 'oszczędź {{amount}} przy {{points}} pkt',
    nearest: 'najbliższa',
    cta: 'Zacznij zbierać — to bezpłatne',
    already_member: 'Masz już konto?',
    sign_in: 'Zaloguj się',
  },
  member: {
    earning_free: 'Zdobywasz darmowe jedzenie',
    every_euro_one: 'Każde wydane {{amount}} = 1 pkt. Wymieniaj na produkty i rabaty.',
    every_euro_few: 'Każde wydane {{amount}} = {{count}} pkt. Wymieniaj na darmowe produkty i zniżki.',
    every_euro_many: 'Każde wydane {{amount}} = {{count}} pkt. Wymieniaj na darmowe produkty i zniżki.',
    every_euro_other: 'Każde wydane {{amount}} = {{count}} pkt. Wymieniaj na produkty i rabaty.',
    until_redeem: '{{remaining}} pkt do rozpoczęcia wymiany',
    unlock_first: 'To zamówienie odblokowuje Twoją pierwszą nagrodę!',
    so_close: 'Tak blisko darmowego jedzenia!',
    just_more: 'Tylko {{remaining}} pkt więcej i zaczniesz oszczędzać.',
    pts_to_unlock: '{{remaining}} pkt do odblokowania nagród',
    this_order_unlocks: 'To zamówienie da Ci {{points}} pkt — możesz je wymienić przy następnym zamówieniu!',
    save_next: 'Oszczędź nawet {{amount}} następnym razem',
    pts_from_order: '+{{earned}} pkt z tego zamówienia — pozostaje tylko {{remaining}}!',
    rewards_value: '= {{amount}} w nagrodach',
    save_this_order: 'Oszczędź nawet {{amount}} na tym zamówieniu',
    use_pts: 'Użyj {{points}} pkt przy kasie',
    earned_this_order: '+{{points}} pkt za to zamówienie',
    current: 'Aktualne',
    from_this_order: '+{{points}} z tego zamówienia',
    expiration_zero: '{{points}} pkt wygasa dzisiaj',
    expiration_one: '{{points}} pkt wygasa za 1 dzień',
    expiration_few: '{{points}} pkt wygasa za {{count}} dni',
    expiration_many: '{{points}} pkt wygasa za {{count}} dni',
    expiration_other: '{{points}} pkt wygasa za {{count}} dni',
  },
};
